// extracted by mini-css-extract-plugin
module.exports = {"wrapp":"SubCategories_wrapp__3YWFU","scrollBarContainer":"SubCategories_scrollBarContainer__p3imk","icon":"SubCategories_icon__34TMF","rightIcon":"SubCategories_rightIcon__2THXi"};